import { IBlocklistAllowlistItem, IListBlocklistAllowlistResponse } from '../entities/blocklist-allowlist-constants';
import { SiteSettingsApiEndpoints } from '../../utils/api-endpoints';
import { get } from 'core/network/RestApi';
import { generatePath } from 'react-router';

export const getBlocklistAllowlist = async (
  siteId: string,
  queryString: string,
): Promise<IBlocklistAllowlistItem[]> => {
  try {
    const result = await get<IListBlocklistAllowlistResponse>(
      generatePath(SiteSettingsApiEndpoints.GET_BLOCK_ALLOW_LIST, { siteId: siteId, queryString: queryString }),
    );
    return result?.data?.data ?? ([] as IBlocklistAllowlistItem[]);
  } catch (e) {
    return [] as IBlocklistAllowlistItem[];
  }
};
